/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Pure UI-version helpers, kept free of imports so they can be unit tested
 * without loading auth/Auth (axios is ESM and does not parse under CRA's jest).
 * See useUiVersion.js for how they are used.
 */

export const UI_LEGACY = "legacy";
export const UI_V2 = "v2";
export const UI_VERSION_STORAGE_KEY = "pearl.uiVersion";

export const VERSIONS = new Set([UI_LEGACY, UI_V2]);

export function isUiV2Enabled(env = process.env) {
  return (
    String(env.REACT_APP_UI_V2_ENABLED ?? "true").toLowerCase() !== "false"
  );
}

export function readStoredUiVersion(storage = safeStorage()) {
  try {
    const value = storage?.getItem(UI_VERSION_STORAGE_KEY);
    return VERSIONS.has(value) ? value : null;
  } catch {
    return null;
  }
}

export function writeStoredUiVersion(version, storage = safeStorage()) {
  try {
    if (version) storage?.setItem(UI_VERSION_STORAGE_KEY, version);
    else storage?.removeItem(UI_VERSION_STORAGE_KEY);
  } catch {
    // Private mode or blocked storage: the server value still applies after load.
  }
}

function safeStorage() {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch {
    return null;
  }
}

/** Pure resolution, exported for tests. */
export function resolveUiVersion({ serverUi, stored, enabled = true }) {
  if (!enabled) return UI_LEGACY;
  if (serverUi && VERSIONS.has(serverUi.version)) return serverUi.version;
  if (VERSIONS.has(stored)) return stored;
  return UI_LEGACY;
}
